import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  bl: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viaje: { value: null, matchMode: FilterMatchMode.CONTAINS },
  pol: { value: null, matchMode: FilterMatchMode.CONTAINS },
  pod: { value: null, matchMode: FilterMatchMode.CONTAINS },
  identificador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  descripcion: { value: null, matchMode: FilterMatchMode.CONTAINS },
  marca: { value: null, matchMode: FilterMatchMode.CONTAINS },
  modelo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  lugarEntrega: { value: null, matchMode: FilterMatchMode.CONTAINS },
  fechaDescarga: { value: null, matchMode: FilterMatchMode.DATE_IS },
  fechaRegistro: { value: null, matchMode: FilterMatchMode.DATE_IS },
};
